// extracted by mini-css-extract-plugin
export default {"userAvatar":"Avatar_userAvatar__PJQDA","avatarContainer":"Avatar_avatarContainer__-I9FE","userNameCircle":"Avatar_userNameCircle__yc6aj","emoji":"Avatar_emoji__FwJyi"};